import { Inject, Injectable } from '@angular/core';
import { ENV } from '@rd/core/tokens/rd-lib.token';
import { FeatureFlags } from '@rd/types/feature-flag.type';
import { AnzEnvironmentType } from 'global-types';

type AnzFeatureFlags = Extract<
  FeatureFlags,
  | FeatureFlags.AutoRedemption
  | FeatureFlags.ShoppingCart
  | FeatureFlags.Merchandise
  | FeatureFlags.Apid
>;

@Injectable()
export class ANZFeatureFlagService {
  constructor(@Inject(ENV) private env: AnzEnvironmentType) {}

  public isProduction = this.env === 'production';

  protected featureFlags: Record<AnzFeatureFlags, boolean> = {
    autoRedemption: true,
    shoppingCart: true,
    merchandise: true,
    apid: true,
  };

  get isAutoRedemptionEnabled(): boolean {
    return this.isEnable(FeatureFlags.AutoRedemption);
  }

  isEnable(featureFlag: AnzFeatureFlags): boolean {
    return !!this.featureFlags[featureFlag];
  }
}
